<div class="report-table">
  <sc-sub-title *ngIf="hasTitleDictionaryKey()" >{{title | translate: [titleDictionaryKey, translationService.language] }}</sc-sub-title>
  <sc-sub-title *ngIf="!hasTitleDictionaryKey() && hasTitle()" >{{title}}</sc-sub-title>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <table class="{{classes}}">
    <thead *ngIf="!hideHeaders">
      <tr>
        <th style="width: 200px"></th><th *ngFor="let column of columns" [ngStyle]="{'min-width': columnWidth}">
          <ng-container *ngIf="hasDictionaryLabel(column)">
            {{column.label | translate: [column.dictionaryKey, translationService.language]}}
          </ng-container>
          <ng-container *ngIf="!hasDictionaryLabel(column)">
            {{column.label}}
          </ng-container>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows; let i = index" >
        <td>{{row.label | translate: [row.dictionaryKey, translationService.language]}}</td>
        <td *ngFor="let column of columns" class="text-right" [ngStyle]="{'min-width': columnWidth}">{{value(i, column.key)}}</td>
      </tr>
    </tbody>


  </table>


</div>
